import axiosInstance from "auth/FetchInterceptor";
import {
  EMAIL_SEND_PURCHASE_ORDER,
  EMAIL_RESEND,
  EMAIL_HISTORY,
  EMAIL_STATUS_SUMMARY,
  EMAIL_DETAIL,
  EMAIL_CAMPAIGN_CREATE,
  EMAIL_CAMPAIGN_UPDATE,
  EMAIL_VERIFY_CREDENTIAL
} from "constants/ApiConstant";

const EmailService = {};

EmailService.sendPurchaseOrderEmail = function (data) {
  return axiosInstance.post(EMAIL_SEND_PURCHASE_ORDER, data);
};

EmailService.resendEmailRecipient = function (recipientId) {
  return axiosInstance.post(`${EMAIL_RESEND}/${recipientId}`);
};

EmailService.getEmailHistory = function (data) {
  return axiosInstance.post(EMAIL_HISTORY, data);
};

EmailService.getEmailStatusSummary = function (data) {
  return axiosInstance.post(EMAIL_STATUS_SUMMARY, data);
};

EmailService.getEmailDetail = function (id) {
  return axiosInstance.get(`${EMAIL_DETAIL}/${id}`);
};

EmailService.createEmailCampaign = function (data) {
  return axiosInstance.post(EMAIL_CAMPAIGN_CREATE, data);
};

EmailService.updateEmailCampaign = function (data) {
  return axiosInstance.post(EMAIL_CAMPAIGN_UPDATE, data);
};

EmailService.verifyCredential = function (apiCredentialId) {
  return axiosInstance.post(`${EMAIL_VERIFY_CREDENTIAL}/${apiCredentialId}`);
};

export default EmailService;